export default "__VITE_ASSET__ae36b5d8__"